export const BACKOFFICE_LOGIN_REQUEST = 'BACKOFFICE_LOGIN_REQUEST';
export const BACKOFFICE_LOGIN_SUCCESS = 'BACKOFFICE_LOGIN_SUCCESS';
export const BACKOFFICE_LOGIN_FAIL = 'BACKOFFICE_LOGIN_FAIL';
export const BACKOFFICE_LOGOUT = 'BACKOFFICE_LOGOUT';
export const BACKOFFICE_REGISTER_SUCCESS = 'BACKOFFICE_REGISTER_SUCCESS';
export const BACKOFFICE_REGISTER_FAIL = 'BACKOFFICE_REGISTER_FAIL';
